import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { TopColumnSlider } from '@/components/modules/pages/top/slider/TopColumnSlider';
import { TopSectionHead } from '@/components/modules/pages/top/typography/head/TopSectionHead';
import { OutlineLinkButton } from '@/components/ui/Button/OutlineLinkButton/OutlineLinkButton';
import { columnListPath } from '@/utils/router/links';
/**
 * TOP: コラム一覧
 * @param props
 * @constructor
 */
export const TopColumn = (props) => {
    const { className = '', items } = props;
    return (_jsxs("div", Object.assign({ className: clsx('bg-base-gray', 'pt-40 lg:pt-64 pb-64 lg:pb-80', className) }, { children: [_jsx("div", Object.assign({ className: 'px-20' }, { children: _jsx(TopSectionHead, { children: "\u4ECA\u6CE8\u76EE\u306E\u30B3\u30E9\u30E0" }) })), _jsx("div", Object.assign({ className: clsx('w-full lg:w-[857px] xl:w-[1208px]', 'pl-16 lg:px-20', 'mt-[17px] lg:mt-36 mx-auto') }, { children: _jsx(TopColumnSlider, { items: items }) })), _jsx("div", Object.assign({ className: clsx('w-[320px] max-w-full', 'mt-[25px] lg:mt-[33px] mx-auto', 'px-20') }, { children: _jsx(OutlineLinkButton, Object.assign({ color: 'blue', isFull: true, size: 'lg', to: columnListPath() }, { children: "\u30B3\u30E9\u30E0\u4E00\u89A7\u3078" })) }))] })));
};
